module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/admin/photo-cb642d95505a52e2b6a59f9d57b32948.svg&quot;;"